import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ApolloLink} from '@apollo/client';
import {GET_ALL_LOBS} from '../queries/lob.query.model';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiLobService {

  private apiGraphqlService = inject(ApiGraphqlService);

  /**
   * Method API: Get all Lobs (used query)
   * @return: Observable
   */
  getAllLobsObservable(): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(GET_ALL_LOBS);
  }

}
